import React from "react";
import { Heading, HeadingProps } from "rebass";

const H1: React.FunctionComponent<HeadingProps> = (props: HeadingProps) => (
  <Heading fontSize={[4, 5, 5]} {...props} />
);
export default H1;
